import { Link } from 'react-router-dom';
import './PlanetLinks.scss'; // You will create this SCSS file

const planetLinks = [
  { title: "Planetary Positions", path: "/planets/planetary-positions" },
  { title: "Planet Transit", path: "/planets/planet-transit" },
  { title: "Planet Combustion", path: "/planets/combustion" },
  { title: "Planet Retrograde", path: "/planets/retrograde" },
  { title: "Planet Conjunction", path: "/planets/conjunction" },
  { title: "Eclipse Dates", path: "/planets/eclipse-dates" },
  { title: "Solar Eclipse", path: "/planets/solar-eclipse" },
  { title: "Lunar Eclipse", path: "/planets/lunar-eclipse" },
  { title: "Indian Seasons", path: "/planets/indian-seasons" },
  { title: "Winter Solstice", path: "/planets/winter-solstice" },
  { title: "Summer Solstice", path: "/planets/summer-solstice" },
];

const PlanetLinks = () => {
  return (
    <div className="planet-link-container">
      <h2 className="planet-link-title">Planetary Events & Movements</h2>
      <div className="planet-link-grid">
        {planetLinks.map((item, index) => (
          <Link key={index} to={item.path} className="planet-link-item">
            <img
              src="https://img.freepik.com/free-photo/space-planet-science-night-generated-by-ai_188544-15619.jpg?semt=ais_incoming&w=740&q=80"
              alt={item.title}
            />
            {item.title}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default PlanetLinks;
